import React, { Component } from 'react';

import MaterialTable from 'material-table';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';

import CPF from 'cpf';
import { format } from 'cnpj';
import moment from 'moment';
import 'moment/locale/pt-br';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import Snackbar from '@material-ui/core/Snackbar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Flag from '@material-ui/icons/Flag';
import CircularProgress from '@material-ui/core/CircularProgress';
import telefone from 'telefone';
import DropZone from '../../components/DropZone';
import { instanceAxios } from '../../InstanceAxios';
import environment from '../../environment';
import Etapas from './components/etapas';
import Documents from './components/documents';
import { uuidAbertura, uuidAberturaMEI } from '../../consts/common';

import useStyles from './styles';
import TableData from './components/TableData';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';

class ServicosContratadosComponent extends Component {
  constructor() {
    super();
    this.axios = instanceAxios(localStorage.getItem('toobiauth'));
    this.tableRef = React.createRef();
    moment.locale('pt-br');
  }

  state = {
    columns: [
      { title: '#', field: 'id', editable: 'never', filtering: false },
      {
        title: 'Prioridade',
        render: (rowData) => {
          const now = moment(new Date());
          // por padrão é rowData.updatedAt caso haja impacto reverter.
          const start = moment(rowData.updatedAt);
          const diff = now.diff(start, 'days');

          return diff <= 7 ? (
            <Flag style={{ color: 'green' }} />
          ) : diff > 7 && diff <= 14 ? (
            <Flag style={{ color: 'yellow' }} />
          ) : (
            <Flag style={{ color: 'red' }} />
          );

          // deixar comentado para validar com o cliente primeiro.
          // return rowData.prioridade === 'Normal' ? (
          //   <Flag style={{ color: 'green' }} />
          // ) : rowData.prioridade === 'Alerta' ? (
          //   <Flag style={{ color: 'yellow' }} />
          // ) : (
          //   <Flag style={{ color: 'red' }} />
          // )
        },
        filtering: false,
      },
      {
        title: 'Serviço',
        field: 'Servico.nome',
        editable: 'never',
        filtering: false,
      },
      {
        title: 'Solicitante',
        field: 'Usuario.nome',
        editable: 'never',
        filtering: false,
      },
      {
        title: 'Data Solicitação',
        field: 'createdAt',
        type: 'date',
        editable: 'never',
        filtering: false,
      },
      {
        title: 'Status',
        field: 'status',
        lookup: { 1: 'Em Aberto', 2: 'Andamento', 3: 'Feito', 4: 'Cancelado' },
      },
      {
        title: 'Responsável',
        field: 'Admin.nome',
        editable: 'never',
        filtering: false,
      },
      {
        title: 'Etapa Abertura',
        field: 'EtapasAbetura.nome',
        render: (rowData) => {
          return <TableData etapas={rowData} />;
        },
        filtering: true,
      },
    ],
    comentario: '',
    idComentario: 0,
    openAlert: false,
    msgAlert: '',
    typeAlert: '',
    openModal: false,
    openModalAddFile: false,
    openModalSteps: false,
    openModalDocuments: false,
    loading: false,
    fileAddMessage: [],
    idServico: 0,
    ready: false,
    selectedPostsMenu: null,
    page: 0,
    pageSize: 5,
    search: '',
    status: [1, 2, 3, 4],
    etapa: '',
  };

  openSelectedPostsMenu = (event, id) => {
    this.setState({ selectedPostsMenu: event.currentTarget });
    this.setState({ idServico: id });
  };

  handleClickPrioridade = (item, prioridade) => {
    new Promise((resolve, reject) => {
      this.axios
        .put(`${environment}/servicosContratados/trocarPrioridade`, {
          id: item,
          prioridade,
        })
        .then((res) => {
          if (res) {
            window.location.reload();
          }
        })
        .catch((err) => {
          alert('Erro ao atualizar Status');
          resolve();
        });
    });
  };

  closeSelectedPostsMenu = (item, prioridade) => {
    if (item && item.cancelable) {
      this.setState({ selectedPostsMenu: null });
    } else {
      this.handleClickPrioridade(item, prioridade);
      this.setState({ selectedPostsMenu: null });
    }
  };

  atualizarServicos = async ({
    page = this.state.page,
    pageSize = this.state.pageSize,
    search = this.state.search,
    status = this.state.status,
    etapa = this.state.etapa,
  }) => {
    return this.axios
      .get(
        `/servicosContratados?page=${page}&limit=${pageSize}&search=${search}&status=${status.toString()}&etapa=${etapa}`
      )
      .then((res) => {
        this.setState({
          page,
          pageSize,
          search,
          status,
          ready: true,
          etapa,
        });
        return res.data;
      })
      .catch((err) => {
        this.setAlert(
          'Erro ao buscar serviços, tente novamente mais tarde!',
          'error',
          true
        );
        return null;
      });
  };

  handleModal = () => {
    this.setState({ openModal: false });
    this.setState({ comentario: '' });
    this.setState({ idComentario: 0 });
    this.clickAlert();
  };

  trocarPrioridade = async () => {};

  handleClick = () => {
    // Checar se o campo comentario esta vazio
    if (this.state.comentario.trim() === '') {
      this.setAlert('Mensagem vázia', 'warning', true);
    } else if (this.state.comentario.length >= 255) {
      this.setAlert('Mensagem muito Longa', 'warning', true);
    } else {
      this.axios
        .post(`${environment}/comentariosservicos`, {
          id_servico_contratado: this.state.idServico,
          comentario: this.state.comentario,
        })
        .then((com) => {
          this.setAlert(
            'Comentário Salvo/Excluido com sucesso',
            'success',
            true
          );
          this.setState({ comentario: '' });
          this.setState({ idComentario: 0 });
          this.setState({ openModal: false });
          this.tableRef.current.onQueryChange();
        })
        .catch((err) => {
          this.setAlert('Erro ao Salvar/Excluido Comentário', 'error', true);
          this.setState({ comentario: '' });
          this.setState({ idComentario: 0 });
        });
    }
  };

  handleAdd = (event, rowData) => {
    this.setState({ openModal: true });
    this.setState({ idServico: rowData.id });
  };

  handleAddFile = (classes) => {
    return (
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={this.state.openModalAddFile}
        onClose={() => this.setState({ openModalAddFile: false })}
      >
        <div className={classes.modalAddTitle}>
          <DropZone handleButtonClick={this.handleButtonClick} />
        </div>
      </Modal>
    );
  };

  handleMenuPrioridade = (classes) => {
    return (
      <div>
        <IconButton
          aria-owns={this.state.selectedPostsMenu ? 'selectedPostsMenu' : null}
          aria-haspopup="true"
          onClick={this.openSelectedPostsMenu}
        >
          <Flag />
        </IconButton>
        <Menu
          id="selectedPostsMenu"
          anchorEl={this.state.selectedPostsMenu}
          open={Boolean(this.state.selectedPostsMenu)}
          onClose={this.closeSelectedPostsMenu}
        >
          <MenuList>
            <MenuItem
              onClick={() => {
                this.closeSelectedPostsMenu(this.state.idServico, 'Normal');
              }}
            >
              <ListItemIcon className="min-w-40">
                <Flag style={{ color: 'green' }} />
              </ListItemIcon>
              <ListItemText primary="Normal" />
            </MenuItem>
            <MenuItem
              onClick={() => {
                this.closeSelectedPostsMenu(this.state.idServico, 'Alerta');
              }}
            >
              <ListItemIcon className="min-w-40">
                <Flag style={{ color: 'yellow' }} />
              </ListItemIcon>
              <ListItemText primary="Alerta" />
            </MenuItem>
            <MenuItem
              onClick={() => {
                this.closeSelectedPostsMenu(this.state.idServico, 'Em atraso');
              }}
            >
              <ListItemIcon className="min-w-40">
                <Flag style={{ color: 'red' }} />
              </ListItemIcon>
              <ListItemText primary="Em atraso" />
            </MenuItem>
          </MenuList>
        </Menu>
      </div>
    );
  };

  clickAlert = () => {
    this.setAlert('', '', false);
  };

  setAlert = (msg, type, open) => {
    this.setState({ msgAlert: msg, typeAlert: type, openAlert: open });
  };

  deleteComment = (idComent) => {
    this.axios
      .delete(`${environment}/comentariosservicos/${idComent}`)
      .then((data) => {
        this.setAlert('Comentário Salvo/Excluido com sucesso', 'success', true);
        this.tableRef.current.onQueryChange();
      })
      .catch((err) => {
        console.log(err);
        this.setAlert('Erro ao Salvar/Excluido Comentário', 'error', true);
      });
  };

  renderComents = (comentarios) => {
    return comentarios.map((com) => (
      <ListItem alignItems="flex-start">
        <ListItemAvatar>
          <Avatar
            alt="Foto de Perfil"
            src="http://portal.xmeibrasil.com.br/storage/images/semFoto.png"
          />
        </ListItemAvatar>
        <ListItemText
          primary={`${com.User.nome} - ${moment(com.createdAt).format('LLL')} `}
          secondary={
            <>
              {com.comentario.split('\n').map((c) => (
                <>
                  <span>{c}</span>
                  <br />
                </>
              ))}
            </>
          }
          style={{ wordWrap: 'break-word' }}
        />
        <ListItemSecondaryAction>
          <IconButton
            edge="end"
            aria-label="delete"
            onClick={() => this.deleteComment(com.id)}
          >
            <DeleteIcon />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
    ));
  };

  serviceIsAberturaBaixaAlteracao = (s) => {
    if (
      s.Servico.uuid &&
      [uuidAbertura, uuidAberturaMEI].includes(s.Servico.uuid)
    ) {
      return true;
    }
    this.setState({
      msgAlert: 'Opção válida apenas para Abertura/Baixa/Aleração',
      typeAlert: 'warning',
      openAlert: true,
    });
    return false;
  };

  render() {
    const { classes } = this.props;

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          paddingTop: 20,
          overflow: 'hidden',
        }}
      >
        <Snackbar open={this.state.openAlert}>
          <Alert severity={this.state.typeAlert} onClick={this.clickAlert}>
            {this.state.msgAlert}
          </Alert>
        </Snackbar>
        <Collapse in={this.state.ready}>
          <MaterialTable
            tableRef={this.tableRef}
            title="Serviços Contratados"
            columns={this.state.columns}
            data={(query) =>
              new Promise(async (resolve, reject) => {
                this.setState({ ready: false });
                const { page, pageSize, search } = query;
                console.log(query.filters);
                let status = '';
                let etapa = '';
                query.filters.forEach((filter) => {
                  if (filter.column.field === 'status') {
                    status = filter.value;
                  } else {
                    etapa = filter.value;
                  }
                });
                const data = await this.atualizarServicos({
                  page,
                  pageSize,
                  search,
                  status,
                  etapa,
                });
                if (data) {
                  resolve({
                    data: data.rows,
                    page,
                    totalCount: data.count,
                  });
                } else {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                }
              })
            }
            style={{ width: '100%' }}
            options={{
              actionsColumnIndex: -1,
              filtering: true,
            }}
            localization={{
              pagination: {
                labelDisplayedRows: '{from}-{to} de {count}',
              },
              toolbar: {
                nRowsSelected: '{0} linha(s) selecionadas',
              },
              header: {
                actions: 'Ações',
              },
              body: {
                emptyDataSourceMessage: 'Nenhum serviço encontrado',
                filterRow: {
                  filterTooltip: 'Busca',
                  filterPlaceHolder: 'Busca',
                },
              },
            }}
            actions={[
              {
                icon: 'flag',
                tooltip:
                  'Verde: Normal; \n Amarelo: Alerta; \n Vermelho: Em atraso',
                onClick: (event, rowData) =>
                  this.openSelectedPostsMenu(event, rowData.id),
              },
              {
                icon: 'comment',
                tooltip: 'Adicionar Comentário',
                onClick: this.handleAdd,
              },
              {
                icon: AttachFileIcon,
                tooltip: 'Anexar documento',
                onClick: (event, rowData) => {
                  this.setState({
                    openModalDocuments: true,
                    idServico: rowData.id,
                  });
                },
              },
              {
                icon: PlaylistAddCheckIcon,
                tooltip: 'Etapas',
                onClick: (event, rowData) => {
                  if (
                    rowData.Servico.nome &&
                    (rowData.Servico.nome.includes('Abertura') ||
                      rowData.Servico.nome.includes('Baixa') ||
                      rowData.Servico.nome.includes('Alteração') ||
                      rowData.Servico.nome.includes('Transformação'))
                  ) {
                    this.setState({
                      openModalSteps: !this.state.openModalSteps,
                      idServico: rowData.id,
                    });
                  }
                },
              },
            ]}
            editable={{
              onRowUpdate: (newData, oldData) =>
                new Promise((resolve, reject) => {
                  this.axios
                    .put(`${environment}/atualizarStatusServico`, {
                      id: newData.id,
                      status: newData.status,
                    })
                    .then((res) => {
                      if (res) {
                        window.location.reload();
                      }
                    })
                    .catch((err) => {
                      alert('Erro ao atualizar Status');
                      resolve();
                    });
                }),
            }}
            detailPanel={[
              {
                tooltip: 'Visualizar Comentários',
                render: (rowData) => {
                  return (
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={12}>
                        <List className={classes.root}>
                          {this.renderComents(rowData.ComentarioServicos)}
                        </List>
                      </Grid>
                    </Grid>
                  );
                },
              },
              {
                icon: 'account_circle',
                tooltip: 'Dados do Solicitante',
                render: (rowData) => {
                  return (
                    <List component="nav" aria-label="mailbox folders">
                      <ListItem>
                        <ListItemText primary="Dados Do Cliente" />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          primary={rowData.Usuario.nome}
                          secondary="Nome"
                        />
                      </ListItem>
                      <Divider />
                      <ListItem>
                        <ListItemText
                          primary={rowData.Usuario.email}
                          secondary="Email"
                        />
                      </ListItem>
                      <Divider />
                      <ListItem>
                        <ListItemText
                          primary={CPF.format(rowData.Usuario.cpf)}
                          secondary="CPF"
                        />
                      </ListItem>
                      <Divider />
                      <ListItem>
                        <ListItemText
                          primary={
                            rowData.Usuario.telefone
                              ? telefone.format(rowData.Usuario.telefone)
                                ? telefone.format(rowData.Usuario.telefone)
                                : rowData.Usuario.telefone
                              : 'Sem Telefone'
                          }
                          secondary="Telefone"
                        />
                      </ListItem>
                      <Divider />
                      {rowData.Usuario.UsuarioEmpresa ? (
                        <>
                          <ListItem>
                            <ListItemText
                              primary={
                                rowData.Usuario.UsuarioEmpresa.Empresa
                                  .razao_social
                              }
                              secondary="Razão Social"
                            />
                          </ListItem>
                          <Divider />
                          <ListItem>
                            <ListItemText
                              primary={format(
                                rowData.Usuario.UsuarioEmpresa.Empresa.cnpj
                              )}
                              secondary="CNPJ"
                            />
                          </ListItem>
                        </>
                      ) : (
                        <></>
                      )}
                    </List>
                  );
                },
              },
            ]}
          />
          {this.handleAddFile(classes)}

          {this.handleMenuPrioridade(classes)}

          <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={this.state.openModal}
            onClose={this.handleModal}
          >
            <div className={classes.paper2}>
              <Grid
                container
                direction="column"
                alignItems="center"
                justifyContent="center"
              >
                <h2 id="simple-modal-title">Adicione um comentário</h2>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                  <TextField
                    multiline
                    fullWidth
                    variant="outlined"
                    rows={8}
                    value={this.state.comentario}
                    onChange={(coment) => {
                      this.setState({ comentario: coment.target.value });
                    }}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                direction="column"
                alignItems="center"
                justifyContent="center"
              >
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className={classes.button}
                  startIcon={<SaveIcon />}
                  onClick={this.handleClick}
                >
                  Salvar
                </Button>
              </Grid>
            </div>
          </Modal>
          <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={this.state.openModalSteps}
            onClose={() => this.setState({ openModalSteps: false })}
          >
            <div className={classes.paper}>
              <Etapas
                idServico={this.state.idServico}
                setAlert={this.setAlert}
                setClose={() => this.setState({ openModalSteps: false })}
              />
            </div>
          </Modal>
          <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={this.state.openModalDocuments}
            onClose={() => this.setState({ openModalDocuments: false })}
          >
            <div className={classes.paper2}>
              <Documents
                idServico={this.state.idServico}
                addFile={this.saveAttachement}
                setClose={() => this.setState({ openModalDocuments: false })}
              />
            </div>
          </Modal>
        </Collapse>
        <Collapse in={!this.state.ready}>
          <CircularProgress className={classes.loading} />
        </Collapse>
      </div>
    );
  }
}

export default withStyles(useStyles)(ServicosContratadosComponent);
